const state = {
  notifications: []
}
const getters = {
  notifications: state => state.notifications
}
const mutations = {
  add_Notification: (state, payload) => {
    var newNotification = {
      text: payload.text,
      color: payload.color
    }
    state.notifications = newNotification
  }
}
const actions = {
  addNotification: (context, payload) => {
    context.commit('add_Notification', payload)
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/notifications/index.js